<mat-card  class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Reminder distribution</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-mat-table-generator #matTable [tableName]="'emailRemindersTable'" *ngIf="remindersDataSource"
      [viewEnabled]="false"
      [editEnabled]="false"
      [deleteEnabled]="false"
      [multiselectEnabled]="false"
      [columns]="remindersColumns" [dataSource]="remindersDataSource">
    </app-mat-table-generator>
  </mat-card-content>
</mat-card>